'use client';

import React, { memo, useMemo } from 'react';
import Image from 'next/image';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick}>
      <Image
        src="/assets/images/0F73B197-0645-40FD-847D-C4CC2CCBEBDF-1781714303568.png"
        alt="NOTICOPA logo"
        width={size}
        height={size}
        className="flex-shrink-0 object-contain"
      />
    </div>
  );
});

export default AppLogo;
